import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, Observable, of, take, tap } from 'rxjs';
import { VersionModel } from './version.model';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgTemplateOutlet, AsyncPipe, DatePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'tm-about-dialog',
    templateUrl: './about-dialog.component.html',
    styleUrls: ['./about-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatDialogTitle,
        MatProgressSpinner,
        NgTemplateOutlet,
        MatDialogActions,
        MatButton,
        AsyncPipe,
        DatePipe,
    ],
})
export class AboutDialogComponent {
  private httpClient = inject(HttpClient);
  public dialogRef = inject<MatDialogRef<AboutDialogComponent>>(MatDialogRef);

  public static VERSIONS_JSON_URL = '/version.json';

  public version$: Observable<VersionModel | null>;

  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  constructor() {
    this.loadingSubject.next(true);
    this.version$ = this.httpClient.get<VersionModel>(AboutDialogComponent.VERSIONS_JSON_URL)
      .pipe(
        take(1),
        catchError((): Observable<VersionModel> => of({
          version: "",
          buildDate: "",
          addedPackages: [],
        })),
        tap(() => this.loadingSubject.next(false)),
      );
  }

  public static open(dialog: MatDialog, options?: MatDialogConfig) {
    return dialog.open(AboutDialogComponent, {
      width: '375px',
      height: '400px',
      ...options,
    });
  }

  public close() {
    this.dialogRef.close();
  }

}
